// extracted by mini-css-extract-plugin
export var videoResponsive = "index-module--video-responsive--iF4s0";